import { lazy, Suspense, useRef } from 'react';
import './AboutMeGrid.css';
import { projectsData } from '../data/projectsData';
import ProjectsSection from '../components/ProjectsSection';
import AboutSection from '../components/AboutSection';
import ExperienceSection from '../components/ExperienceSection';
import PhotoSection from '../components/PhotoSection';
import GalleryFooter from '../components/GalleryFooter';
import ContactMeasures from '../components/ContactMeasures';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const SimpleScene = lazy(() =>
    import('../components/SimpleScene').then((mod) => ({
        default: mod.SimpleScene ?? mod.default,
    }))
);

const Home = () => {
    const aboutSectionRef = useRef<HTMLDivElement>(null);
    const experienceSectionRef = useRef<HTMLDivElement>(null);

    useIntersectionObserver({
        targetRef: aboutSectionRef,
        onIntersect: () => {
            if (aboutSectionRef.current) {
                aboutSectionRef.current.classList.add('in-view');
            }
        },
        rootMargin: '-30% 0px -50% 0px',
    });

    useIntersectionObserver({
        targetRef: experienceSectionRef,
        onIntersect: () => {
            if (experienceSectionRef.current) {
                experienceSectionRef.current.classList.add('in-view');
            }
        },
        rootMargin: '-30% 0px -50% 0px',
    });

    return (
        <>
            <main className="hero">
                <article className="hero-copy">
                    <p className="hero-overline">Product builder &amp; systems thinker</p>
                    <h1>
                        I love juggling between product, development, infra &amp; business
                    </h1>
                    <p className="hero-body">
                        My goal is to build products that make a difference, blending development, design thinking, and business strategy.
                    </p>

                    <div className="hero-pills">
                        <span>Builder</span>
                        <span>Dreamer</span>
                        <span>Learner</span>
                    </div>
                </article>

                <section className="hero-showcase" aria-label="Identity animation">
                    <Suspense fallback={<div className="showcase-fallback">Loading…</div>}>
                        <SimpleScene className="hero-visual" />
                    </Suspense>
                </section>
            </main>

            <section className="about-me-grid" id="about">
                <div className="about-section" ref={aboutSectionRef}>
                    <h2 className="section-title">About</h2>
                    <AboutSection />
                </div>
                <div className="experience-section" ref={experienceSectionRef}>
                    <h2 className="section-title">Experience</h2>
                    <ExperienceSection />
                </div>
                <PhotoSection />
            </section>

            <section id="projects">
                <ProjectsSection projects={projectsData} />
            </section>

            <GalleryFooter />

            <ContactMeasures />
        </>
    );
};

export default Home;
